import { Component } from '@angular/core';

@Component({
  selector: 'admin-default-form-demo',
  templateUrl: './default-form-demo.component.html',
  styleUrls: ['./default-form-demo.component.scss'],
})
export class DefaultFormDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/form/control/default-form/default-form-demo.component.ts